import { createListenerMiddleware } from "@reduxjs/toolkit";
import { loginSuccess } from "./authSlice";
import { adminApi } from "../redux/admin/adminApi";
import { groupAdminApi } from "../redux/groupAdminApi";
import { creditsApi } from "../redux/admin/creditsApi";
import { dashboardApi } from "../redux/admin/dashboardApi";
import { logisticsApi } from "../redux/logistics/logisticsApi";
import { taskApi } from "../redux/admin/taskApi";
import { groupApi } from "../redux/admin/groupApi";
import { userApi } from "../redux/admin/userApi";
import { protocolApi } from "../redux/protocol/protocolApi";
import { alarmApi } from "../redux/admin/alarmApi";
import { cameraApi } from "../redux/admin/cameraApi";
import { streamApi } from "../redux/admin/streamApi";
import { screenshotApi } from "../redux/admin/screenshotApi";
import { historyApi } from "../redux/admin/historyApi";
import { reportApi } from "../redux/admin/reportApi";
import { deviceApi } from "../redux/admin/deviceApi";
import { inventoryApi } from "../redux/admin/inventoryApi";
import { jt808Api } from "../redux/admin/jt808Api";
import { rechargePlanApi } from "../redux/admin/rechargePlanApi";
import { supportTicketApi } from "../redux/admin/supportTicketApi";
import { calendarApi } from "../redux/admin/calendarApi";

const AUTH_SCOPED_APIS = [
  adminApi,
  groupAdminApi,
  creditsApi,
  dashboardApi,
  logisticsApi,
  taskApi,
  groupApi,
  userApi,
  protocolApi,
  alarmApi,
  cameraApi,
  streamApi,
  screenshotApi,
  historyApi,
  reportApi,
  deviceApi,
  inventoryApi,
  jt808Api,
  rechargePlanApi,
  supportTicketApi,
  calendarApi,
];

const getAuthIdentity = (auth = {}) => ({
  userId: String(auth?.user?._id || auth?.user?.id || ""),
  token: String(auth?.token || ""),
});

// RTK Query cache keys do not include the active JWT. On Login As, an existing
// mounted query would otherwise keep the previous account's cached response.
export const authCacheMiddleware = createListenerMiddleware();

authCacheMiddleware.startListening({
  actionCreator: loginSuccess,
  effect: (_, api) => {
    const previous = getAuthIdentity(api.getOriginalState()?.auth);
    const current = getAuthIdentity(api.getState()?.auth);

    if (previous.userId === current.userId && previous.token === current.token) return;

    AUTH_SCOPED_APIS.forEach((service) => {
      api.dispatch(service.util.resetApiState());
    });
  },
});
